import $ from 'jquery';

$(document).ready(function() {
    var navbar = document.getElementById("menu-principal");
    var menuLogo = document.getElementById("menu-logo");
    var sticky = navbar.offsetTop;
    window.onscroll = function() {myFunction()};
    function myFunction() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("navbar-sticky")
            menuLogo.classList.add("menu-logo")
            menuLogo.classList.remove("is-hidden")
        } else {
            navbar.classList.remove("navbar-sticky");
            menuLogo.classList.remove("menu-logo")
            menuLogo.classList.add("is-hidden")
        }
    }


    /* eslint-disable no-unused-vars */
    var slideIndex = 1;
    var bannerIndex = 0;
    showSlides(slideIndex);
    carousel();

    $("#prev").on("click", function() {
        showSlides(slideIndex += -1);
    });
    $("#next").on("click", function() {
        showSlides(slideIndex += 1);
    });
    function currentSlide(n) {
        showSlides(slideIndex = n);
    }

    function showSlides(n) {
        var i;
        var slides = document.getElementsByClassName("diapositiva");
        if (slides.length > 0) {
            var captionText = document.getElementById("titulo");
            if (n > slides.length) {slideIndex = 1}
            if (n < 1) {slideIndex = slides.length}
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            slides[slideIndex-1].style.display = "block";
            captionText.innerHTML = $(slides[slideIndex-1]).data("titulo");
        }
    }

    function carousel() {
        var i;
        var x = document.getElementsByClassName("banner");
        if (x.length > 0){
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
            bannerIndex++;
            if (bannerIndex > x.length) {bannerIndex = 1}
            x[bannerIndex-1].style.display = "block";
            setTimeout(carousel, 5000);
        }
    }
    /* eslint-enable no-unused-vars */

    $(".navbar-burger").click(function() {
        $(".navbar-burger").toggleClass("is-active");
        $(".navbar-menu").toggleClass("is-active");
    });

    $(".has-dropdown").on("click", function () {
        if ($("#menu-logo").is(':visible')) {
            $(this).toggleClass("is-active");
        }
    });

    $(".navbar-item.has-dropdown").click(function () {
        var menu_logo = $("#menu>div.img-logo");
        if (menu_logo.is(":visible")){
            $(this).toggleClass("is-active");
            console.log(menu_logo);
        }
    });

    $(".informacion.button").click(function (e) {
        e.preventDefault();
        var the_id = $(this).attr('id');
        var target = $(".adjuntos."+the_id);
        target.fancybox().attr('data-fancybox',the_id);
        target.eq(0).click();
    });

    var $noticia_imgs = $('.blockgallery--item img');
    var fb = [];

    $noticia_imgs.each(function(index, img) {
        fb.push({
            src : img.src,
            type: 'image',
            $orig : $(img).parent(),
        })
    });

    $('.blockgallery--item').on('click', 'img', function() {
        $.fancybox.open(fb, {
            // Here you can put your custom options
        }, $noticia_imgs.index(this))
    });

    /* eslint-disable no-undef */
    $(".filtro_categoria").on("change", function () {
        var combo = document.getElementById($(this).attr('id'));
        if ( combo.options[combo.selectedIndex].value != 0 ) {
            var tax = combo.options[combo.selectedIndex].getAttribute('data-tax');
            var url = globals.home_url + "/";
            url+= combo.name + "/";
            url+= tax != null ? tax + "/" : '';
            url+=combo.options[combo.selectedIndex].value;
            // eslint-disable-next-line no-undef
            location.href = url;
        }
    });

    var accordion_localidades = $("#localidades_estados");
    if (accordion_localidades.length > 0) {
        accordion_localidades.accordion({
            header: ".advgb-accordion-header",
            heightStyle: "content",
            collapsible: true,
        });
    }
});



// WEBPACK FOOTER //
// resources/assets/scripts/limay.js